import { useState, FC } from "react";
import StdLiveNavBar from "../../components/StdLiveNavBar";
import stdGroup from "../Assets/Images/stdG.svg";
import calenderIcon from "../Assets/Images/calender.svg";
import submitIcon from "../Assets/Images/submit.svg";
import "../Assets/css/stdLive.scss";

export interface IExamState {
	state?: "live" | "ended";
	setLiveStudents?: (count: number) => unknown;
	setEnrolledStudents?: (count: number) => unknown;
	setSubmittedUsers?: (count: number) => unknown;
	changeExamDate?: (date: string) => unknown;
	changeExamState?: (state: "live" | "ended") => unknown;
	submittedCount?: number;
	unSubmittedCount?: number;
	setUnSubmittedCount?: (count: number) => unknown;
	changeExamData?: (options: {
		courseName: string;
		examName: string;
	}) => unknown;
}

type TstdLiveWrapper = (
	WrapperStudentData: FC<IExamState>,
	WrapperDownloadData: FC<IExamState>,
	options: {
		paramName: string;
	}
) => () => JSX.Element;
const stdLiveWrapper: TstdLiveWrapper = (
	WrapperStudentData,
	WrapperDownloadData
) => {
	const ExamState: FC<IExamState> = (props) => {
		if (props.state === "live") {
			return <WrapperStudentData {...props} />;
		} else {
			return <WrapperDownloadData {...props} />;
		}
	};

	ExamState.defaultProps = {
		state: "live",
		setLiveStudents: (count: number) => {},
		setEnrolledStudents: (count: number) => {},
		setSubmittedUsers: (count: number) => {},
		setUnSubmittedCount: (count: number) => {},
		changeExamDate: (date: string) => {},
		submittedCount: 0,
		unSubmittedCount: 0,
	};

	return () => {
		const [totalStudent, setTotalStudent] = useState(0);
		const [examStatus, setExamStatus] = useState<"live" | "ended">("live");
		const [courseName, setCourseName] = useState("");
		const [examName, setExamName] = useState("");
		const [totalSubmittedUsers, setTotalSubmittedUsers] = useState(0);
		const [totalStudentsWhoEnrolled, setTotalStudentsWhoEnrolled] =
			useState(0);
		const [examDate, setExamDate] = useState("");
		const [unSubmittedCount, setUnSubmittedCount] = useState<number>(0);

		function setExamData(options: {
			courseName: string;
			examName: string;
		}) {
			const { courseName, examName } = options;
			setCourseName(courseName);
			setExamName(examName);
		}

		function changeExamStatus(status: "live" | "ended"): void {
			setExamStatus(status);
		}

		function changeTotalLiveStudents(count: number) {
			setTotalStudent(count);
		}

		function totalEnrolledStudents(count: number) {
			setTotalStudentsWhoEnrolled(count);
		}

		function changeTotalSubmittedUsers(count: number) {
			setTotalSubmittedUsers(count);
		}

		function changeExamDate(val: string) {
			setExamDate(val);
		}
		return (
			<div className="stdLive">
				<StdLiveNavBar />
				<div className="stdNameTitle">
					{courseName}-{examName}
				</div>
				<br></br>
				<div className="stdliveHead">
					<div className="flex w-full flex-col lg:flex-row">
						<div className="m-2 lg:w-full">
							<div className="liveScorecard">
								<div className="scoreHead">
									{examStatus === "live"
										? "Live Students"
										: "Exam Ended"}
								</div>
								<hr />
								<div className="LiveScore p-10 sm:p-6">
									<div className="flex flex-col sm:flex-row sm:align-center sm:justify-around">
										<div>
											<div
												className="liveName"
												style={{
													lineHeight:
														examStatus === "live"
															? "4"
															: "1.5",
													// set font normal and color gray if it's not live
													fontWeight:
														examStatus === "live"
															? "bold"
															: "normal",
													color:
														examStatus === "live"
															? "gray"
															: "gray",
													fontSize:
														examStatus === "live"
															? "20px"
															: "18px",
												}}
											>
												{examStatus === "live" && (
													<span className="live-icon"></span>
												)}{" "}
												{examStatus === "live" ? (
													<p className="inline">
														LIVE STUDENT
													</p>
												) : (
													<p>
														Exam has ended. Now you
														can download the result.
													</p>
												)}
											</div>
										</div>

										{examStatus === "live" && (
											<div className="flex justify-center items-center">
												<div className="liveNum">
													{totalStudent
														? totalStudent
														: 0}
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="m-2 lg:w-[70%]">
							<div className="stdInformation lg:flex lg:align-center lg:justify-center">
								<div className="grid sm:grid-cols-2 gap-4 align-center">
									<div className="flex align-center justify-start my-2 mx-4">
										<img
											width={20}
											height={20}
											src={stdGroup}
											alt="students"
										/>
										<div className="flex flex-col justify-center text-xs ml-3">
											<span className="text-[#575757] font-semibold">
												Total Student
											</span>
											<span>
												{totalStudentsWhoEnrolled}
											</span>
										</div>
									</div>
									<div className="flex align-center justify-start my-2 mx-4">
										<img
											width={20}
											height={20}
											src={calenderIcon}
											alt="calender"
										/>
										<div className="flex flex-col justify-center text-xs ml-3">
											<span className="text-[#575757] font-semibold">
												Exam Date
											</span>
											<span>{examDate}</span>
										</div>
									</div>
									<div className="flex align-center justify-start my-2 mx-4">
										<img
											width={20}
											height={20}
											src={submitIcon}
											alt="exam submit"
										/>
										<div className="flex flex-col justify-center text-xs ml-3">
											<span className="text-[#575757] font-semibold">
												Exam Submitted
											</span>
											<span>{totalSubmittedUsers}</span>
										</div>
									</div>
									<div className="flex align-center justify-start my-2 mx-4">
										<img
											width={20}
											height={20}
											src={submitIcon}
											alt="exam unsubmitted"
										/>
										<div className="flex flex-col justify-center text-xs ml-3">
											<span className="text-[#575757] font-semibold">
												Exam UnSubmitted
											</span>
											<span>{unSubmittedCount}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<hr />
				<ExamState
					state={examStatus}
					setLiveStudents={changeTotalLiveStudents}
					setEnrolledStudents={totalEnrolledStudents}
					setSubmittedUsers={changeTotalSubmittedUsers}
					changeExamDate={changeExamDate}
					submittedCount={totalSubmittedUsers}
					unSubmittedCount={unSubmittedCount}
					setUnSubmittedCount={setUnSubmittedCount}
					changeExamState={changeExamStatus}
					changeExamData={setExamData}
				/>
			</div>
		);
	};
};

export default stdLiveWrapper;
